import { Sprite } from 'pixi.js'
import { FT, Scene, Spine } from 'ft'
import { timer } from 'ft/utils'
import hooks from '#/hooks'
import store from '#/store'
import bgm from '#/bgm'
import track from '#/track'

const $SPINE = 'spine.SC04'
const $soundSelect = 'sound.ui-select'
const $soundOK = 'sound.ui-ok'
const $box = 'bedroom-box'
const $quilt1 = 'bedroom-quilt1'
const $quilt2 = 'bedroom-quilt2'
const $quilt3 = 'bedroom-quilt3'
const $buttonOK = 'share-ok'

const { rm } = FT

rm.addSpine($SPINE)
rm.addSound($soundSelect)
rm.addSound($soundOK)
rm.addImage($box)
rm.addImage($quilt1)
rm.addImage($quilt2)
rm.addImage($quilt3)
rm.addImage($buttonOK)

class Bedroom extends Scene {
  constructor(name) {
    super(name)

    track(`${store.type}-scene3`, `${store.type}-场景3`)

    this.render()
  }

  render = async () => {
    bgm.env.stop()

    const SPINE = new Spine(rm.spine($SPINE))
    this.SPINE = SPINE
    SPINE.scale.set(0.5)
    SPINE.position.set(FT.stage.centerX, FT.stage.centerY)
    SPINE.state.setAnimation(0, 'SC04_Loop', true)
    SPINE.skeleton.setAttachment('Quilt', null)
    this.addChild(SPINE)

    await timer.delay(500)
    this.addBox({
      onSelect: ({ target }) => {
        const id = target.name
        if (id) {
          store.quilt = id
          this.previewQuilt(id)
          rm.sound($soundSelect).play()
        }
      },
      onOK: () => {
        if (store.quilt) {
          track(`select-quilt.${store.quilt}`, '选择被子')
          rm.sound($soundOK).play()
          this.nextScene()
          hooks.onSelectQuilt()
        }
      },
    })
  }

  previewQuilt(id) {
    this.SPINE.skeleton.setAttachment('Quilt', `SC04/Quilt_0${id}`)
  }

  addBox({ onSelect, onOK }) {
    const { rm } = FT
    const box = new Sprite(rm.texture($box))
    box.interactive = true
    box.anchor.set(0.5, 1)
    box.x = FT.stage.centerX
    box.y = FT.stage.bounds.bottom - 70
    this.addChild(box)
    ;['1', '2', '3'].forEach((name, index) => {
      const quilt = new Sprite(rm.texture(`bedroom-quilt${name}`))
      quilt.name = name
      quilt.interactive = true
      quilt.anchor.set(0.5)
      quilt.y = -220
      quilt.x = (index - 1) * 200

      box.addChild(quilt)
    })
    const buttonOK = new Sprite(rm.texture($buttonOK))
    buttonOK.interactive = true
    buttonOK.anchor.set(0.5, 1)
    buttonOK.y = -34
    box.addChild(buttonOK)

    box.on('pointerup', onSelect)
    buttonOK.on('pointerup', onOK)
  }

  nextScene = () => {
    FT.sm.load('bed', { transition: true })
  }
}

export default Bedroom
